<!-- template for the modal component -->
<template>
  <transition name="modal">
    <div class="modal-mask" :style="{ 'display: none' : closed }">
      <div class="modal-wrapper">
        <div class="modal-container" id="container">
          <transition name="fade">
            <img 
              v-show="scrolling"
              class="indicator" 
              :src="imgPath + 'icon_scroller.svg'"
              :style="`top: ${ scrollPos }px;`"
            />
          </transition>
          <button 
            class="modal-default-button c-btn--close" 
            @click="$emit('close'); closed = true"
          >x</button> 
          <div ref="scrolledElement" class="modal-content" @scroll="showScroll"> 
            <div class="modal-header">
              <slot name="header"/>
            </div>
              
            <div class="modal-body">
              <slot name="body"/>
            </div>
      
          </div>
          <div class="modal-footer">
            <slot name="footer"/>
          </div>  
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
        imgPath: process.env.IMAGES_PATH,
        scrolling: false,
        scrollPos: 0, 
        closed: false
    }
  },
  methods: {
    showScroll() { 
      var sE = this.$refs.scrolledElement
      var windowHeight = document.getElementById("container").clientHeight
      this.scrollPos = 30 + (0.7 * windowHeight * sE.scrollTop / (sE.scrollHeight - windowHeight))
    }
  },
  watch: {
    scrollPos: function() {
        this.scrolling = true
        var that = this
        setTimeout(() => that.scrolling = false, 1500)
    }
  }
}

</script>

<style scoped lang="scss">
.indicator {
  position: relative;
  float: right;
  margin-right: -10px;
}

.fade-leave-active {
  transition: all .5s ease
}

.modal-mask {
  position: fixed;
  z-index: 4000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 50%;
  // min-width: 20rem;
  max-width: 45rem;
  margin: 1rem auto;
  padding: 1.7rem 2rem 2rem 2rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  overflow: hidden;
  .modal-default-button {
    float: right;
    margin: -5px -5px 0 0;
  }
}

.modal-content {
  max-height: 80vh;
  overflow-y: auto;
  padding-right: 1rem;
  &::-webkit-scrollbar {
  width: 0;
  }
  .modal-header h3 {
    margin-top: 0;
  }
  .modal-body {
    /* margin: 20px 10px; */
    margin: 0px;
  }
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.c-btn--close{
    border: none;
    background: none;
    color: #EE3224;
    font-size: 25px;
    padding: 0px;
}
</style>
